<div class="bs-input-div" >
      <div [formGroup]="getFormGroup()">
            <label [for]="'chk_' + getId()" 
                   class="checkbox-label bs-label th-text-main"
                   [class.checkbox-cursor]="!getReadOnly()">
                  <input type="checkbox" 
                        #el
                        [id]="'chk_' + getId()"
                        hidden
                        class="checkbox-input th-bg-checkbox"
                        [formControlName]="getModelId()">

                  <div  class="th-input-checkbox checkbox-box aling-check me-2"
                        [class.checkbox-disable]="getReadOnly()"
                        [class.th-bg-dark-disabled]="getReadOnly()"
                        [class.th-dark-disabled-border]="getReadOnly()" 
                        [class.checkbox-cursor]="!getReadOnly()">
                  </div>
                  {{getLabelValue()}}
            </label>
      </div>
</div>          
